app.sidebarNav = (function () {
  'use strict';

  let items = document.querySelectorAll('[data-sidebar-nav]');

  function init() {
    if (items.length === 0) return;

    items.forEach((item) => {
      const trigger = item.querySelector('[data-sidebar-nav-trigger]');
      const container = item.querySelector('[data-sidebar-nav-container]');

      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        if (trigger.classList.contains('is-active') === false) {
          openNav(item, trigger, container, true);
        } else {
          closeNav(item, trigger, container, true);
        }
      });
    });

    // window.addEventListener(
    //   'resize',
    //   () => {
    //     reset();
    //   },
    //   { passive: true }
    // );

    reset();
  }

  const reset = util.debounce(() => {
    if (items.length === 0) return;

    items.forEach((item) => {
      const trigger = item.querySelector('[data-sidebar-nav-trigger]');
      const container = item.querySelector('[data-sidebar-nav-container]');

      if (window.matchMedia(breakpoint_lg).matches) {
        openNav(item, trigger, container, false);
      } else {
        closeNav(item, trigger, container, false);
      }
    });
  }, 250);

  function openNav(item, trigger, container, animate) {
    trigger.classList.add('is-active');

    // a11y: update aria attributes
    trigger.setAttribute('aria-label', trigger.dataset.closeText);
    trigger.setAttribute('aria-expanded', true);

    if (animate) {
      util.slideDown(container, 250);
    } else {
      container.style.display = 'block';
      container.style.visibility = 'visible';
    }
  }

  function closeNav(item, trigger, container, animate) {
    trigger.classList.remove('is-active');

    // a11y: update aria attributes
    trigger.setAttribute('aria-label', trigger.dataset.openText);
    trigger.setAttribute('aria-expanded', false);

    if (animate) {
      util.slideUp(container, 250);
    } else {
      container.style.display = 'none';
      container.style.visibility = 'hidden';
    }
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();
